import React from 'react';
import { Box, VStack, HStack, Label, Text, Button } from '@medely/ui-kit';
import avatarStack from '@mp/assets/images/avatar-stack.png';
import { useProNavigate } from '@mp/contexts';

export type HighVolumeProps = {
  shiftsCount: number;
  minPay: number;
  maxPay: number;
};

function getQueryParam(key: string): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return new URLSearchParams(window.location.search).get(key);
}

function isFromAppWebview() {
  const fromApp = getQueryParam('fromApp');
  const webView = getQueryParam('webView');
  return fromApp === '1' || webView === '1';
}

const HighVolume: React.FC<HighVolumeProps> = ({ shiftsCount, minPay, maxPay }) => {
  const { navigate } = useProNavigate();
  const fromApp = isFromAppWebview();
  const displayMinPay = (minPay / 100).toFixed(2);
  const displayMaxPay = (maxPay / 100).toFixed(2);

  const handleClick = () => {
    if (fromApp) {
      // @ts-ignore
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          action: 'navigate',
          screen: 'FindJobs',
        }),
      );
    } else {
      navigate('FindJobs');
    }
  };

  return (
    <Box bgColor="surface.backing-1" borderRadius="8px" p={2} mt={2} width="100%">
      <VStack alignItems="flex-start">
        <Label size="m">Last month, {shiftsCount} shifts were available near you.</Label>
        <HStack alignItems="center" mb={1}>
          <img
            src={avatarStack}
            alt="Avatar stack"
            width={80}
            height={48}
            style={{ flexShrink: 0, marginRight: '0.5rem' }}
          />
          <Text size="s" color="text.secondary">
            Shifts in this area are paying ${displayMinPay}–${displayMaxPay} per hour
          </Text>
        </HStack>
        <Button variant="outlined" onClick={handleClick}>
          Find jobs
        </Button>
      </VStack>
    </Box>
  );
};

export default HighVolume;
